export function schema_textrazor(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			colonne: {
				title: "Colonne",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			topic: {
				type: "boolean",
				title: "Premier thème",
				default: true,
				format: "checkbox",
			},
			topics: {
				type: "boolean",
				title: "Tous les thèmes",
				default: true,
				format: "checkbox",
			},
			categorie: {
				type: "boolean",
				title: "Première catégorie",
				default: true,
				format: "checkbox",
			},
			categories: {
				type: "boolean",
				title: "Toutes les catégories",
				default: true,
				format: "checkbox",
			},
			types: {
				type: "boolean",
				title: "Elements analysés",
				default: true,
				format: "checkbox",
			},
			freebase_types: {
				type: "boolean",
				title: "Elements analysés - deuxième méthode",
				default: true,
				format: "checkbox",
			},
			type: {
				title: "Types à isoler",
				format: "table",
				type: "array",
				items: {
					type: "object",
					title: "type",
					properties: {
						column: {
							title: "Colonne",
							type: "string",
							options: {
								inputAttributes: {
									class: "form-control dropdown-colonne",
								},
							},
						},
						type: {
							title: "Type",
							type: "string",
							options: {
								inputAttributes: {
									class: "form-control dropdown-colonne",
								},
							},
						},
					},
				},
			},
		},
	};
}
